import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/")({
  component: RouteComponent,
  beforeLoad: async () => {
    throw redirect({ to: "/beheer/cursisten" })
  },
})

function RouteComponent() {
  return <ScreenWrapper showManagementMenu>Beheer</ScreenWrapper>
}
